import React from 'react'
import { Editor } from 'primereact/editor'

const CustomEditor = ({
  value = '',
  onChange = () => {},
  placeholder = 'Start typing...',
  height = '250px',
  className = '',
  ...rest
}) => {
  return (
    <Editor
      value={value}
      onTextChange={e => onChange(e.htmlValue)}
      style={{ height }}
      className={`mt-2 w-full ${className}`}
      placeholder={placeholder}
      {...rest}
    />
  )
}

export default CustomEditor
